import moment from "moment";
import { numberWithCommas, removeDuplicates } from "./helper";
const DefaultColors = [
	"#D14040",
	"#7F40D1",
	"#2D76E5",
	"#1BBC86",
	"#E2E22D",
	"#92661A",
	"#EB9563",
	"#E5897F",
	"#E24E89",
	"#C063E8",
	"#63B3E8"
];

/**
 * parse jwt
 * @param {*} token 
 * @returns 
 */
const parseJwt = token => {
	const base64Url = token.split(".")[1];
	const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	const jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function(c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);

	return JSON.parse(jsonPayload);
};


/**
 * get key value data
 * @param {*} data 
 * @param {*} configuration 
 * @param {*} withPercent 
 * @returns 
 */
const getKeyValueData = (data, configuration, withPercent) => {
	const resData = [];
	let totalCount = 0;
	const colors = [];
	const columns = configuration.columns;
	columns.map((item, index) => {
		const filters = item.filters;
		let count = 0;
		const columnData = data;
		filters.forEach(element => {
			const result = columnData.filter(function(v){
				return (
					v[element.key] ==
					element.values.find(value => value == v[element.key])
				);
			});
			count = count + (result || []).length;
		});
		totalCount += count;
		const color = item.color || colors[index];
		colors.push(color);
		resData.push({ attributeValue: count, attributeName: item.name });
	});
	if (withPercent) {
		for (let i = 0; i < resData.length; i++) {
			resData[i].percentage = Math.round(
				(resData[i].attributeValue / totalCount) * 100
			);
		}
		return { data: resData, colors: colors };
	}
	return resData;
};

/**
 * get columns
 * @param {*} data 
 * @returns 
 */
const getColumns = data => {
	if (data == undefined || data.length == 0) {
		return [];
	}

	const unique = [
		...new Set(data.map(item => item.ServiceLocation + "#" + item.ServiceSide))
	];
	const columns = [];
	unique.map((item) => {
		const Indexer = item.split("#");
		const column = {
			name: Indexer[0] + " - " + Indexer[1],
			type: "count",
			filters: [
				{
					key: "ServiceLocation",
					values: [Indexer[0]]
				},
				{
					key: "ServiceSide",
					values: [Indexer[1]]
				}
			]
		};

		columns.push(column);
	});

	return columns;
};

/**
 * get charts data
 * @param {*} data 
 * @param {*} configuration 
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} type 
 * @returns 
 */
const getChartData = (data, configuration, startDate, endDate, type) => {
	const columns = configuration.columns;

	const resData = [];
	const mainAccessor = getSeries(startDate, endDate, type);
	const CharAccessor = {};
	CharAccessor.mainAccessor = type;
	const colors = [];
	const barKeys = [];
	const barColors = [];
	const legends = [];

	mainAccessor.map(month => {
		const object = {};

		if (type == "Day") {
			object[type] = month.label;
		} else {
			object[type] = month;
		}

		columns.map((item, index) => {
			CharAccessor["line" + index] = item.name;

			const filters = item.filters;
			let columnData = [...data];

			let filterResult = [];

			filters.forEach(element => {
				const result = columnData.filter(function(v) {
					const res =
						v[element.key] ==
						element.values.find(value => value == v[element.key]);

					return res;
				});
				filterResult = [...result];
				columnData = [...result];
			});
			let max = 0;
			filterResult.forEach(el => {
				let isValid = false;

				switch (type) {
					case "Month":
					case "Week":
						if (
							moment(el[configuration.trend.key]).format("MM/DD/YY") == month
						) {
							isValid = true;
						}
						break;
					case "Day":
						object[type] = month.label;
						if (
							moment(el[configuration.trend.key]).format("H") == month.startHrs
						) {
							isValid = true;
						}
						break;
					case "YTD":
						if (moment(el[configuration.trend.key]).format("MMM YY") == month) {
							isValid = true;
						}
						break;

					default:
						break;
				}

				if (isValid == true) {
					max = (max || 0) > el["Value"] ? max : el["Value"] || 0;
					const index = data.findIndex(
						obj => obj["DeviceMappingId"] === el["DeviceMappingId"]
					);
					data =
						index >= 0
							? [...data.slice(0, index), ...data.slice(index + 1)]
							: data;
				}
			});

			const color =
				item.color ||
				(DefaultColors[index] || DefaultColors[index / DefaultColors.length]);
			if (barKeys.find(value => value == item.name) == undefined) {
				barColors.push(color);
				barKeys.push(item.name);
				legends.push({ label: item.name, color: color });
			}

			object[item.name] = max;
			colors[item.name] = color;
		});
		resData.push(object);
	});
	return {
		chartAccessor: CharAccessor,
		data: resData,
		colors: colors,
		barKeys: barKeys,
		barColors: barColors,
		legends
	};
};

/**
 * get series
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} type 
 * @returns 
 */
const getSeries = (startDate, endDate, type) => {
	const result = [];
	startDate = moment(startDate);
	endDate = moment(endDate);

	switch (type) {
		case "Month":
			while (startDate.isBefore(endDate)) {
				result.push(startDate.format("MM/DD/YY"));
				startDate.add(1, "day");
			}
			result.push(endDate.format("MM/DD/YY"));
			break;
		case "Week":
			while (startDate.isBefore(endDate)) {
				result.push(startDate.format("MM/DD/YY"));
				startDate.add(1, "day");
			}
			result.push(endDate.format("MM/DD/YY"));
			break;
		case "Day":
			for (let i = 0; i < 24; i++) {
				result.push({
					label: (i > 10 ? i : "0" + i) + ":00",
					startHrs: i,
					endHrs: i + 1
				});
			}
			break;
		case "YTD":
			while (startDate.isBefore(endDate)) {
				result.push(startDate.format("MMM YY"));
				startDate.add(1, "month");
			}
			result.push(endDate.format("MMM YY"));
			break;

		default:
			break;
	}

	return result;
};

/**
 * data format
 */
const DataFormat = {
	PercentNumber: "PercentNumber",
	PercentDecimal: "PercentDecimal",
	Number: "Number"
};
const getPropertyNoCase = (obj, prop) =>
	obj[Object.keys(obj).find(key => key.toLowerCase() === prop.toLowerCase())];

const getFormattedString = (value, Format, defaultValue = "-") => {
	if (value === undefined || value === "" || value === null) {
		return defaultValue;
	}
	switch (Format) {
		case DataFormat.PercentNumber:
		case DataFormat.PercentDecimal:
			return getPercentLabel(value);
		case DataFormat.Number:
			if (isNaN(value)) return defaultValue;
			return numberWithCommas(value);
		default:
			return numberWithCommas(value);
	}
};

/**
 * get percentage title
 * @param {*} value 
 * @returns 
 */
const getPercentLabel = value => {
	if (value == undefined || value == "") {
		return "-";
	}
	value += "%";
	return value;
};

/**
 * details by attribute and type
 * @param {*} attributeName 
 * @param {*} type 
 * @param {*} array 
 * @returns 
 */
const detailByAttributeAndType = (attributeName, type, array) => {
	const DataArray = array;

	const result = DataArray.filter(
		value =>
			value.AttributeName == attributeName && value.AttributeSubType == type
	);
	return result;
};

/**
 * check negative values
 * @param {*} value 
 * @param {*} round 
 * @returns 
 */
const checkNegative = (value, round = true) => {
	if (value == undefined) {
		value = 0;
	} else {
		value = parseFloat(value);
	}
	let Numbers;

	if (parseInt(value) == 0 || isNaN(parseInt(value))) {
		return "-";
	}
	if (round == true) {
		Numbers = parseInt(String(Math.round(value)));
	} else {
		if (isNaN(value) == true) {
			return "-";
		} else {
			Numbers = value.toFixed(2);
		}
	}
	if (Numbers < 0) {
		const obj = parseInt(Numbers * -1);
		if (isNaN(obj)) {
			return "-";
		}
		//console.log("(" + parseFloat(value * -1).toLocaleString() + ")");
		return "(" + (Numbers * -1).toLocaleString() + ")";
	}
	//console.log(parseFloat(Numbers).toLocaleString());
	return numberWithCommas(Numbers);
};

/**
 * password validation
 * @param {*} str 
 * @returns 
 */
const validatePassword = str => {
	const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
	return re.test(str);
};

/**
 * get DW Id
 * @param {*} DcID 
 * @param {*} data 
 * @returns 
 */
const getDwId = (DcID, data) => {
	let a;
	//console.log(data);
	data.map(item => {
		if (item.propertyID == DcID || item.propertyID.toString() == DcID) {
			a = item.dwPropertyId;
		}
	});
	return a;
};

/**
 * Format conversion
 * @param {*} optionArr 
 * @param {*} idKey 
 * @param {*} valueKey 
 * @param {*} extraKey1 
 * @returns 
 */
function convertIntoDDFormat(
	optionArr = [],
	idKey = "",
	valueKey = "",
	extraKey1 = "ListOrderBy"
) {
	const supportedArr = [];
	optionArr.map((x) => {
		const valueLength = 0; //x[valueKey].split(",").length;
		const idLength = 0; //x[idKey].split(",").length;
		supportedArr.push({
			value:
				valueLength > 1 ? removeDuplicates(x[valueKey].split(",")) : x[valueKey],
			id: idLength > 1 ? removeDuplicates(x[idKey].split(",")) : x[idKey],
			...(extraKey1 && { [extraKey1]: x[extraKey1] })
		});
	});
	return supportedArr;
}


/**
 * call on search inputs
 * @param {*} data 
 * @param {*} searchText 
 * @param {*} pKey 
 * @returns 
 */
function getSearchedProperty(data, searchText = "", pKey = "property") {
	const searchKey = searchText.toLowerCase().trim();
	if (data === undefined || data === null) return [];
	return data.filter(function(item) {
		function findProperty(params) {
			let isFind = false;
			for (let i = 0; i < params.length; i++) {
				if (params[i][pKey].toLowerCase().includes(searchKey)) {
					isFind = true;
					break;
				} else if (params[i].subRows && params[i].subRows.length) {
					findProperty(params[i].subRows);
				}
			}
			return isFind;
		}
		if (searchKey === "" || item[pKey].toLowerCase().includes(searchKey)) {
			return true;
		} else if (item.subRows && item.subRows.length) {
			return findProperty(item.subRows);
			
		}
	});
}

/**
 * get phone number with mask
 * @param {*} phone 
 * @returns 
 */
function getPhoneNumberWithMask(phone) {
	if (phone && phone.length == 10) {
		const cleaned = ("" + phone).replace(/\D/g, "");
		const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
		if (match) {
			return match[1] + "-" + match[2] + "-" + match[3];
		}
	}
	return phone;
}

/**
 * encode email
 * @param {*} emailText 
 * @returns 
 */
function encodeEmail (emailText) {
    const email = emailText.split("@");
    const domain = email[1];
    const firstName = email[0];
    const b = firstName.substring(2, firstName.length);
    const c = "*";
    const cc = c.repeat(firstName.length - 2);
    const encoded = firstName.replace(b, cc);
    const arr = [];
    arr.push(encoded);
    arr.push(domain);
    
    return arr.join("@");
  }

export {
	getPropertyNoCase,
	parseJwt,
	getFormattedString,
	getChartData,
	getSeries,
	getKeyValueData,
	getColumns,
	detailByAttributeAndType,
	checkNegative,
	validatePassword,
	getDwId,
	convertIntoDDFormat,
	getSearchedProperty,
	getPhoneNumberWithMask,
	encodeEmail
};

// parseJwt(localStorage.getItem("adal.idtoken"));
